import { render, staticRenderFns } from "./Reps.vue?vue&type=template&id=24abf97a&"
import script from "./Reps.vue?vue&type=script&lang=js&"
export * from "./Reps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports